import { useEffect } from 'react';

import { useUnit } from 'effector-react';

import { userStore } from 'apps/customer/state/user';

import { onboardingSessionStore, setIsReturningUser } from './onboardingSession';

/**
 * Classifies a user who already has an authenticated session (e.g. opening an enterprise or
 * subscription invite link while signed in) as a returning user. Phone verification is the only
 * other place `isReturningUser` is set, and these users never go through it, so without this the
 * step guard treats them as unverified and sends them back to the phone screen.
 */
export function useClassifySignedInUser() {
  const { authenticated } = useUnit(userStore);
  const { isReturningUser } = useUnit(onboardingSessionStore);

  useEffect(() => {
    if (authenticated === true && isReturningUser === null) setIsReturningUser(true);
  }, [authenticated, isReturningUser]);
}
